// GENERATED by shared/waypoint-glyphs/regen.sh - do not edit.
// Edit the SVGs in shared/waypoint-glyphs/ and re-run that script.
//
// These are the identical files mobile bakes into PNGs, so a waypoint
// looks the same on both platforms by construction rather than by
// someone remembering to copy a path across.

export const WAYPOINT_BODY_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
  <path d="M16 1.6 C8.3 1.6 2.2 7.8 2.2 15.4 C2.2 25.6 16 40.4 16 40.4 C16 40.4 29.8 25.6 29.8 15.4 C29.8 7.8 23.7 1.6 16 1.6 Z"
        fill="__FILL__" stroke="#FFFFFF" stroke-width="2.2" stroke-linejoin="round"/>
</svg>`;

export const WAYPOINT_GLYPH_SVG = {
  pin: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
  <g fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"
     transform="translate(16 15.2) scale(0.62) translate(-24 -21.5)">
    <path d="M17.8 27.6 L27.8 16.3"/>
    <path d="M22.2 13.7 C25.7 14.6 29.4 17.4 31.4 21.5"/>
  </g>
</svg>`,
  flag: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
  <g transform="translate(16 15.4) scale(0.62) translate(-10.5 -12)">
    <path d="M5 21V4l11 3-4 3 4 3-11 3" fill="none" stroke="#fff" stroke-width="1.9" stroke-linejoin="round"/>
  </g>
</svg>`,
  star: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
  <g transform="translate(16 15.4) scale(0.62) translate(-12 -12)">
    <polygon points="12,3 14.6,9 21,9.5 16,13.8 17.6,20 12,16.5 6.4,20 8,13.8 3,9.5 9.4,9" fill="none" stroke="#fff" stroke-width="1.7" stroke-linejoin="round"/>
  </g>
</svg>`,
  sample: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
  <g transform="translate(16 15.4) scale(0.62) translate(-12 -12)">
    <polygon points="12,4 20,10 17,20 7,20 4,10" fill="#fff"/>
  </g>
</svg>`,
  drill: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
  <g transform="translate(16 15.4) scale(0.62) translate(-12 -12)">
    <polygon points="12,4 21,20 3,20" fill="#fff"/>
  </g>
</svg>`,
  hazard: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
  <g transform="translate(16 15.4) scale(0.62) translate(-12 -12)">
    <path d="M10.3 4 2 18a1.5 1.5 0 0 0 1.3 2.2h17.4A1.5 1.5 0 0 0 22 18L13.7 4a2 2 0 0 0-3.4 0z" fill="none" stroke="#fff" stroke-width="1.8" stroke-linejoin="round"/>
    <line x1="12" y1="9" x2="12" y2="14" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/>
    <circle cx="12" cy="17" r="0.9" fill="#fff"/>
  </g>
</svg>`,
  outcrop: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">
  <g transform="translate(16 15.4) scale(0.62) translate(-12 -16)">
    <path d="M3 20l6-8 4 5 3-4 5 7z" fill="none" stroke="#fff" stroke-width="1.8" stroke-linejoin="round"/>
  </g>
</svg>`,
};
